export function isMobileBrowser() {
    return window.matchMedia('(pointer:coarse)').matches;
}